const ScrollToPlugin = {
	install (Vue) {
	
		Vue.prototype.$scrollTo = function (id, duration, customOffset, callback) {
			
			// Adapted from https://pawelgrzybek.com/page-scroll-in-vanilla-javascript/
			
			var destination = document.getElementById(id);

			const dcHeaderSize = 85;
			if (typeof customOffset !== 'undefined') {
				dcHeaderSize = dcHeaderSize - customOffset;
			}

			const easings = {
				easeInOutQuad(t) {
					return (t < 0.5) ? 2 * t * t : -1 + (4 - 2 * t) * t;
				},
			};

			const start = window.pageYOffset;
			const startTime = ('now' in window.performance) ? performance.now() : new Date().getTime();

			const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
			const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
			const destinationOffset = (typeof destination === 'number') ? destination - dcHeaderSize : destination.offsetTop - dcHeaderSize;
			const destinationOffsetToScroll = (Math.round(documentHeight - destinationOffset < windowHeight) ? documentHeight - windowHeight : destinationOffset);

			if (destinationOffset===0 || window.pageYOffset === destinationOffset) return;

			if ('requestAnimationFrame' in window === false) {
				window.scroll(0, destinationOffsetToScroll);
				if (callback) {
					callback();
				}
				return;
			}

			function scroll() {

				//if (start>dcHeaderSize && window.pageYOffset<=dcHeaderSize) return;
				
				if (!dcTakeoverScroll) return;

				const now = ('now' in window.performance) ? performance.now() : new Date().getTime();
				const time = Math.min(1, ((now - startTime) / duration));
				const timeFunction = easings['easeInOutQuad'](time);
				const nextOffset = Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start);

				if (nextOffset<0) return;
				window.scroll(0, nextOffset);
				if (window.pageYOffset === destinationOffsetToScroll) {
					if (callback) {
						callback();
					}
					return;
				}

				requestAnimationFrame(scroll);
			}

			// This is added to ensure that the scroll takeover only executes for a specific amount of time and/or stops when the user scrolls.
			let dcTakeoverScroll = true;
			scroll();

			function stopScroll() {
				clearTimeout(dcTakeoverScrollTimeout);
				dcTakeoverScroll = false;
				window.removeEventListener("wheel", stopScroll, true);
			}

			let dcTakeoverScrollTimeout = setTimeout(function() {
				stopScroll();
			}, duration + 50);

			window.addEventListener("wheel", stopScroll, true);

		}
	}

}

export default ScrollToPlugin